
//import './libs/detectizr/modernizr-custom';
//import './libs/detectizr/detectizr.min';
//import '@iconfu/svg-inject/dist/svg-inject';

//import $ from 'jquery';

import Main from './src/main';

$(document).ready( ()=>{

	const app = new Main({
		is_ajax 			: true,
		debug				: false,
		slide_transition	: false,
		time_fade_in 		: 0.35,
		time_fade_out 		: 0.25,
		project_name		: 'Ayers Saint Gross',

		
		GA_MEASUREMENT_ID 	: 'UA-50532474-1',
		G4_PROPERTY 		: 'G-X877RCSHXV',
		
		redirects			: [
			['/practice/', '/practice/about/']
		]

	});

	app.init()
	
});